import React from 'react'
import { observer } from 'mobx-react-lite'

import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { CreditCard, ContentCopy, Savings } from '@mxenabled/mx-icons'

import { TabContentContainer, useGlobalCopyStore } from '../../common'

import KeyIndicatorsSpendTab from './KeyIndicatorsSpendTab'
import KeyIndicatorsSaveTab from './KeyIndicatorsSaveTab'
import KeyIndicatorsBorrowTab from './KeyIndicatorsBorrowTab'

const KeyIndicatorsTabsWidget: React.FC = () => {
  const [tabValue, setTabValue] = React.useState(0)
  const { finstrong: copy } = useGlobalCopyStore()

  return (
    <>
      <Tabs
        aria-label={'Key Indicators'}
        centered={true}
        onChange={(_, val) => setTabValue(val)}
        selectionFollowsFocus={true}
        sx={{
          mb: 0,
          '& .MuiTab-root': {
            minWidth: 0,
          },
        }}
        textColor="primary"
        value={tabValue}
        variant="fullWidth"
      >
        <Tab
          aria-controls="spend-details-tabpanel-0"
          icon={<CreditCard sx={{ mr: 8 }} />}
          iconPosition="start"
          id="spend-details-tab-0"
          label={copy.key_indicators_spend.title}
          sx={{ minHeight: 44 }} // TODO : remove it once the theme is updated
        />
        <Tab
          aria-controls="save-details-tabpanel-1"
          icon={<Savings sx={{ mr: 8 }} />}
          iconPosition="start"
          id="save-details-tab-1"
          label={copy.key_indicators_save.title}
          sx={{ minHeight: 44 }} // TODO : remove it once the theme is updated
        />
        <Tab
          aria-controls="borrow-details-tabpanel-2"
          icon={<ContentCopy sx={{ mr: 8 }} />}
          iconPosition="start"
          id="borrow-details-tab-2"
          label={copy.key_indicators_borrow.title}
          sx={{ minHeight: 44 }} // TODO : remove it once the theme is updated
        />
      </Tabs>

      <TabContentContainer index={0} name="spend-details" value={tabValue}>
        <KeyIndicatorsSpendTab />
      </TabContentContainer>

      <TabContentContainer index={1} name="save-details" value={tabValue}>
        <KeyIndicatorsSaveTab />
      </TabContentContainer>

      <TabContentContainer index={2} name="borrow-details" value={tabValue}>
        <KeyIndicatorsBorrowTab />
      </TabContentContainer>
    </>
  )
}

export default observer(KeyIndicatorsTabsWidget)
